var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{ref:"sponsors",attrs:{"id":"sponsors"}},_vm._l((_vm.ads),function(ad){return _c('SponsorSlider',{key:ad})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }